"use strict";
/**
 * @module Topics
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
/**
 * Read a Topic ID from the stream
 *
 * @param bis the input stream
 * @return    the Topic ID that was read
 */
function read(bis) {
    return Codec.readInt32(bis);
}
exports.read = read;
/**
 * Write a Topic ID to the stream
 *
 * @param bos   the output stream
 * @param value the Topic ID to be written
 */
function write(bos, value) {
    Codec.writeInt32(bos, value);
}
exports.write = write;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/topics/details/topic-id-serialiser.js
// module id = 1706
// module chunks = 1